import React from "react";
import { useI18n } from "@/lib/i18n";
import Seo from "@/components/Seo";
export default function ForBrands() {
  const { t, locale } = useI18n();
  return (
    <>
      <Seo title="For brands" description="How brands can claim their profile and submit missing public links." canonicalPath="/for-brands" locale={locale} />
      <div className="bp-container py-16 max-w-3xl">
        <h1 className="font-serif text-5xl mb-6">For brands</h1>
        <div className="space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--bp-text-secondary)" }}>
          <p>If your brand is in the index, you can claim your profile at no cost. Claiming lets you submit publicly available links we may have missed — sustainability reports, factory lists, take-back programmes, certifications with verifiable references.</p>
          <p>Claiming a profile does not change our neutrality. All submitted information is reviewed against public sources before publication and cited transparently in the profile&apos;s changelog.</p>
          <p>To claim, please contact us with proof that you represent the brand. This is a free service.</p>
        </div>
      </div>
    </>
  );
}
